/**
 * @Author:
 * @Description:
 * @DateTime: Created in 19:16 2019-07-25
 */

export default class FileUtil {


	/**
	 * 下载
	 * @param String objectName 表单的action
	 */
	static download (url: string) {
		try {
			var link = document.createElement('a');
			link.href = url;
			document.body.appendChild(link);//添加到页面中，为兼容Firefox浏览器
			link.click();
			document.body.removeChild(link);//从页面移除
		}
		catch (e) {
			console.log('e', e);
		}
	}
    

	/**
	 * 
	 * @param url 通过url预览文件
	 */
	public static urlPreviewFile(url: string)
	{
		try {
			window.open(url)
		} catch (e) {
			console.log('e', e)
		}
	}
    
	/**
	 * 通过url进行文件下载
	 */
	public static urlDownloadFile(url: string, fileName: string)
	{
		const info = document.createElement('a')
        fetch(url).then(res => res.blob()).then(blob => {

			info.href = URL.createObjectURL(blob)
			info.download = fileName
			document.body.appendChild(info)
			info.click()
		})
	}

	// export default {
	// 	bind(el, binding) {
	// 	  el.addEventListener('click', () => {
	// 		console.log(binding.value) // url
	// 		const a = document.createElement('a')
	// 		//   let url = baseUrl + binding.value // 若是不完整的url则需要拼接baseURL
	// 		const url = binding.value // 完整的url则直接使用
	// 		// 这里是将url转成blob地址，
	// 		fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
	// 		  a.href = URL.createObjectURL(blob)
	// 		  console.log(a.href)
	// 		  a.download = '' // 下载文件的名字
	// 		  // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
	// 		  document.body.appendChild(a)
	// 		  a.click()
	// 		})
	// 	  })
	// 	}
	//   }
}
